class Ajax {

    static get(url, data) {
        return this._call(url, data, Ajax.GET);
    }

    static post(url, data) {
        return this._call(url, data, Ajax.POST);
    }

    static put(url, data) {
        return this._call(url, data, Ajax.PUT);
    }

    static patch(url, data) {
        return this._call(url, data, Ajax.PATCH);
    }

    static delete(url, data) {
        return this._call(url, data, Ajax.DELETE);
    }

    /**
     * @param {string} url
     * @param data
     * @param {string} method
     * @returns {Promise<any>}
     * @private
     *
     * Ajax wrapper to automatically handle errors such as a session expiration or csrf token expiration.
     * Sanitizes URLs adding the Web Root if needed
     * Forces the actual HTTP mehtod to either GET or POST. Adds _method property to the data if needed to tell Laravel actually requested method.
     *
     */
    static _call(url, data, method) {
        data = (data ? data : {});

        return new Promise((resolve, reject) => {

            let web_root = '/';

            if (!url.match(/^http/)) {  // If string doesn't start with http, concatenate web_root
                web_root = web_root.replace(/\/$/g, '') + '/'; // Ensures web_root has trailing slash
                url = url.replace(/^\/|\/$/g, '');  // Strips leading and trailing slashes
                url = `${web_root}${url}`;
            }

            let request = {
                method: 'get',
                url: url,
                data: null,
            };

            if (method === Ajax.GET) {
                if (data) {
                    request.url += (url.match(/\?/) !== null ? '&' : '?');
                    request.url += Ajax._objectToQueryParams(data);
                }
            } else {
                data._method = method;
                request.method = 'post';
                request.data = data;
            }

            axios(request)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    let response = null;

                    switch (error.response.status) {
                        case 301:
                        case 302:
                        case 307:
                            if(error.response.data && error.response.data.redirect_url && error.response.data.redirect_url) {
                                location.replace(error.response.data.redirect_url);
                            } else {
                                location.replace('/');
                            }
                            break;
                        case 401:   // Session Expired
                            window.notifier.alert('Your session has expired. Please refresh the page and try again.');
                            break;
                        case 419: // CSRF expired maybe? Looks like it
                            window.notifier.alert('The page has expired. Please refresh the page and try again.');
                            break;
                        case 404: // Not Found 
                        case 405: // Method not allowed
                        case 500: // Server error
                            window.notifier.alert('There was an error with your request. Please try again.');
                            break;
                        case 503: // Maintenance mode
                            window.notifier.alert('The system is currently undergoing maintenance. Please try again later.');
                            break;
                        default:
                            response = {
                                response: error.response,
                                message: error.message,
                            }
                    }

                    reject(response);
                });

        });

    }

    static _objectToQueryParams(obj) {
        let queryParams = [];
        _.forOwn(obj, (value, key) => {
            let newKey = encodeURIComponent(key);
            let newValue = encodeURIComponent(typeof value === 'object' ? JSON.stringify(value) : value);
            queryParams.push(`${key}=${newValue}`);
        })
        return queryParams.join('&');
    }

}

Ajax.GET = 'GET';
Ajax.POST = 'POST';
Ajax.PUT = 'PUT';
Ajax.PATCH = 'PATCH';
Ajax.DELETE = 'DELETE';

module.exports = Ajax;
